export const CART_ELLIPSIS_ID = {
  DELETE_CART: 'deleteCartTab',
  DUPLICATE_CART: 'duplicateCartTab',
  REASSIGN_CART: 'reassignCartTab',
  CLEAR_CART: 'clearCartTab',
  ADD_ALL_TO_LIST: 'addAllToListTab',
} as const;
